document.addEventListener('DOMContentLoaded', function() {
  var tabs = document.querySelectorAll('[data-mf-json]');

  tabs.forEach(function(tab) {
    var jsonStr = tab.getAttribute('data-mf-json');
    var tabId = tab.getAttribute('data-mf-tab-id');

    try {
      var doc = JSON.parse(jsonStr);
      var html = '';

      if (Array.isArray(doc)) {
        // List type metafield - array of strings
        html = parseListArray(doc);
      } else if (doc && doc.type === 'root' && doc.children) {
        // Rich text - Shopify Document format
        html = parseShopifyDocument(doc);
      } else if (typeof doc === 'string') {
        // Plain string
        html = '<p>' + escapeHtml(doc) + '</p>';
      }

      if (html) {
        var contentDiv = document.getElementById('Product-content-' + tabId);
        if (contentDiv) {
          var innerDiv = contentDiv.querySelector('.collapsible-content__inner');
          if (innerDiv) {
            innerDiv.innerHTML = html;
          }
        }
      }
    } catch(e) {
      console.log('Could not parse metafield JSON');
    }
  });
});

function parseListArray(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return '';

  var items = arr.map(function(item) {
    return '<li>' + escapeHtml(item) + '</li>';
  }).join('');

  return '<ul>' + items + '</ul>';
}

function parseShopifyDocument(doc) {
  if (!doc.children) return '';

  return doc.children.map(function(node) {
    if (node.type === 'paragraph') {
      var text = (node.children || []).map(function(child) {
        if (child.type === 'text') {
          var val = escapeHtml(child.value);
          if (child.bold) val = '<strong>' + val + '</strong>';
          if (child.italic) val = '<em>' + val + '</em>';
          if (child.code) val = '<code>' + val + '</code>';
          return val;
        }
        return '';
      }).join('');
      return '<p>' + text + '</p>';
    }

    if (node.type === 'heading') {
      var level = node.level || 1;
      var text = (node.children || []).map(function(child) {
        return escapeHtml(child.value || '');
      }).join('');
      return '<h' + level + '>' + text + '</h' + level + '>';
    }

    if (node.type === 'list') {
      var listType = (node.listType === 'ordered') ? 'ol' : 'ul';
      var items = (node.children || []).map(function(item) {
        var text = (item.children || []).map(function(child) {
          return escapeHtml(child.value || '');
        }).join('');
        return '<li>' + text + '</li>';
      }).join('');
      return '<' + listType + '>' + items + '</' + listType + '>';
    }

    return '';
  }).join('');
}

function escapeHtml(text) {
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  return text.replace(/[&<>"']/g, function(m) { return map[m]; });
}
